import React, { useState } from 'react';
import * as styles from './ExportCSVDialog.css.ts';
import { DataSet } from '../../types';
import logger from '../utils/logger';
import { Dialog } from './common/Dialog';
import { Button } from './common/Button';

interface ExportCSVDialogProps {
  isOpen: boolean;
  onClose: () => void;
  datasets: DataSet[];
  onExport: (datasetIds: string[]) => void;
}

export const ExportCSVDialog: React.FC<ExportCSVDialogProps> = ({
  isOpen,
  onClose,
  datasets,
  onExport
}) => {
  const [selectedDataset, setSelectedDataset] = useState<string | null>(null);

  if (!isOpen) return null;

  const handleSelectDataset = (datasetId: string) => {
    setSelectedDataset(datasetId);
  };

  const handleExport = () => {
    if (!selectedDataset) {
      logger.warn('[ExportCSVDialog] No dataset selected');
      return;
    }

    logger.info('[ExportCSVDialog] Exporting dataset:', selectedDataset);
    onExport([selectedDataset]);
    onClose();
  };

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title="Export Data as CSV"
      width="md"
      footer={
        <>
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleExport}
            disabled={!selectedDataset}
          >
            Export
          </Button>
        </>
      }
    >
      <div
      >
        <p className={styles.description}>
          Select a dataset to export as CSV:
        </p>

        <div className={styles.datasetList}>
        {datasets.length === 0 ? (
          <div className={styles.emptyState}>
            No datasets available to export
          </div>
        ) : (
          datasets.map(dataset => {
            const isDerived = dataset.type === 'derived';
            return (
              <div key={dataset.id} className={styles.datasetRow}>
                <label className={styles.checkboxLabel}>
                  <input
                    type="radio"
                    name="dataset-selection"
                    checked={selectedDataset === dataset.id}
                    onChange={() => handleSelectDataset(dataset.id)}
                  />
                  <div className={styles.datasetInfo}>
                    <span className={styles.datasetName}>
                      {dataset.name}
                      {isDerived && <span className={styles.badge}> (Derived)</span>}
                    </span>
                    <span className={styles.datasetDetails}>
                      {dataset.rowCount} rows × {Object.keys(dataset.schema.columns).length} columns
                    </span>
                  </div>
                </label>
              </div>
            );
          })
        )}
        </div>
      </div>
    </Dialog>
  );
};